export default __webpack_public_path__ + "static/media/incidents_card.e4610abd.jpg";